var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_vm._m(0):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CategoryFiltersMobile',{attrs:{"tier":0,"entity-type":_vm.entityType,"category-filter":_vm.categoryFilter}})}]

export { render, staticRenderFns }